<app-payment-panel-stripe-generic
  [type]="paymentMethodHandles.StripeBancontact"
></app-payment-panel-stripe-generic>
